import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { IMenuDetails } from "libraries/hotel/models/menu-details";
import { MenuDetailsService } from "libraries/hotel/components/menu-details/services/menu-details.service";
import { ITablePrice } from "./ITablePrice";
import {
    IGetBookingsStayResponse,
    TGetBookingResponse
} from "libraries/service/resources/booking/interfaces/IGetBookings";
import { BookingPriceCardService } from "./booking-price-card.service";
import { CardComponent } from "libraries/ui_card/card.component";
import { ConditionsTabService } from './components/conditions-tab/conditions-tab.service';
import { ICondition } from './components/conditions-tab/ICondition';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { BookingType } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { IStayPriceColsHeaders } from "./components/stay-price-tab/interfaces/stay-price-cols-headers";
import { ColsHeaderMappingService } from "./components/stay-price-tab/service/cols-header-mapping.service";
import { IStayPriceRow } from "./components/stay-price-tab/interfaces/stay-price-row";
import { RowsMappingService } from "./components/stay-price-tab/service/rows-mapping.service";
import { ISummarySectorStay } from "../sectors/components/shared/interfaces/ISummary";
import { SectorService } from "libraries/service/sector/sector.service";
import {
    IVehicleRentalPriceColsHeaders,
    IVehicleRentalPriceRow
} from "./components/vehicle-rental-price-tab/interfaces/vehicle-rental-price-intefaces";
import { CarModel } from "libraries/models/car/car.model";
import { makeModel } from "libraries/service/utils/utils.service";
import { ColsNamesEnum } from "./components/stay-price-tab/interfaces/cols-names.enum";
import { DisplayType } from "libraries/component/menu-details-tarifications/menu-details-tarifications.component";
import {
    MenuDetailsTarificationsService
} from "libraries/component/menu-details-tarifications/services/menu-details-tarifications.service";
import { PricesTableService } from "./services/prices-table.service";


export enum MenuTabs {
    prices = 'prices',
    conditions = 'conditions',
    buy = 'buy',
    sale = 'sale',
}

const items: IMenuDetails[] = [
    {
        code: MenuTabs.prices,
        name: Yii.t('wui-shared-js', 'Prix'),
        exist: true,
        selected: true
    },
    {
        code: MenuTabs.conditions,
        name: Yii.t('wui-shared-js', 'Conditions'),
        exist: true,
        selected: false
    }
];

const itemsTarifications: IMenuDetails[] = [
    {
        code: MenuTabs.buy,
        name: Yii.t('wui-shared-js', 'Achat'),
        exist: true,
        selected: true
    },
    {
        code: MenuTabs.sale,
        name: Yii.t('wui-shared-js', 'Vente'),
        exist: true,
        selected: false
    }
];

@Component({
    selector: 'booking-price-card',
    template: `
        <ng-container *ngIf="bookingData && bookingData.price.length">
            <card #cardContainer [isCollapsible]="true" class="collapsible">
                <div class="card-header-content">
                    <div class="title" (click)="menuToggleCard()">
                        {{ cardLabels.title }}
                    </div>
                    <menu-details
                            *ngIf="(bookingData?.type[0] === bookingType?.stay || 
                            bookingData?.type[0] === bookingType?.vehicleRental) || (!hasNewPayload && bookingData?.type?.length && bookingData?.type[0] === bookingType?.air)"
                            class="tabs-field"
                            [items]="menuItems" (onChangeTab)="changeTab($event)">
                    </menu-details>

                    <menu-details-tarifications
                            *ngIf="hasNewPayload && bookingData?.type?.length && bookingData?.type[0] === bookingType?.air"
                            class="tabs-field"
                            [hasRetailInPayload]="hasRetailInPayload"
                            [itemsTarifications]="menuItemsTarifications"
                            (onChangeTab)="changeTabTarifications($event)"
                            (onShowPricesDetailsChange)="onShowPricesDetailsChange($event)">
                    </menu-details-tarifications>
                </div>

                <div class="card-body-content">
                    <div class="booking-data-content">
                        <stay-price-tab
                                *ngIf="selectedTab === menuTabPrices && bookingData.type.length && bookingData.type[0] === bookingType.stay"
                                [sectors]="sectors"
                                [colsHeader]="colsHeader"
                                [dataSourceTotal]="totalRows"
                                [dataSourceDetails]="detailsRows"
                                [prices]="stayPrices"
                                [booking]="bookingData"></stay-price-tab>
                        <price-tab
                                *ngIf="(selectedTab === menuTabPrices) && (!hasNewPayload && bookingData.type.length && bookingData.type[0] === bookingType.air)"
                                [prices]="prices"
                                [travellers]="bookingData.traveller"></price-tab>

                        <ng-container *ngIf="showPricesSummary || showPricesDetails">
                            <prices-summary
                                    *ngIf="(selectedTab === menuTabBuy || selectedTab === menuTabSale) || (hasNewPayload && bookingData.type.length && bookingData.type[0] === bookingType.air)"
                                    [selectedTab]="selectedTab"
                                    [displayListOrTable]="display"
                                    [booking]="bookingData.booking">
                            </prices-summary>
                        </ng-container>

                        <vehicle-rental-price-tab *ngIf="selectedTab === menuTabPrices && isVehicleRentalBooking"
                                                  [isVehicleRentalBooking]="isVehicleRentalBooking"
                                                  [colsHeader]="vehicleColsHeader"
                                                  [dataSourceTotal]="vehicleTotalRows"
                                                  [dataSourceDetails]="vehicleDetailsRows"
                                                  [bookingExtraData]="bookingExtraData"></vehicle-rental-price-tab>

                        <conditions-tab *ngIf="selectedTab === menuTabConditions" [conditions]="conditions"></conditions-tab>
                    </div>
                </div>
            </card>
        </ng-container>

    `,
    styleUrls: ['../card.scss']
})

export class BookingPriceCardComponent implements OnChanges {
    @Input()
    public bookingData: TGetBookingResponse;

    @Input()
    public isVehicleRentalBooking?: boolean;

    @Input()
    public bookingExtraData: any = null;

    @Output()
    public readonly onCardTitleClick: EventEmitter<string> = new EventEmitter();

    @ViewChild('cardContainer')
    public cardContainer: CardComponent;

    public cardLabels: ILabels = {
        title: Yii.t('wui-shared-js', 'Tarifications'),
        hideDetails: Yii.t('wui-shared-js', 'Cacher les détails'),
        showDetails: Yii.t('wui-shared-js', 'Montrer les détails'),
    };

    public hasLocalPrices: boolean;
    public menuItems: IMenuDetails[] = items;
    public menuItemsTarifications: IMenuDetails[] = itemsTarifications;
    public selectedTab: MenuTabs = MenuTabs.prices;
    public prices: ITablePrice;
    public stayPrices: ITablePrice;
    public error: Error;
    public conditions: ICondition;
    public name: string = 'bookingPrice';
    public bookingType: typeof BookingType = BookingType;
    public hasNewPayload?: boolean;
    public hasRetailInPayload: boolean = false;
    public colsHeader: IStayPriceColsHeaders;
    public totalRows: IStayPriceRow[];
    public detailsRows: IStayPriceRow[];
    public sectors: ISummarySectorStay[];
    public vehicleTotalRows: IVehicleRentalPriceRow[];
    public vehicleColsHeader: IVehicleRentalPriceColsHeaders;
    public vehicleDetailsRows: IVehicleRentalPriceRow[];
    public vehicleRentalBookingModel: CarModel = null;
    public showPricesDetails: boolean = false;
    public showPricesSummary: boolean = true;
    public display: DisplayType = DisplayType.pricesTable;
    public menuTabPrices: string = MenuTabs.prices;
    public menuTabConditions: string = MenuTabs.conditions;
    public menuTabBuy: string = MenuTabs.buy;
    public menuTabSale: string = MenuTabs.sale;

    constructor(
        private readonly menuDetailsService: MenuDetailsService,
        private readonly menuDetailsTarificationsService: MenuDetailsTarificationsService,
        private readonly bookingPriceCardService: BookingPriceCardService,
        private readonly conditionsTabService: ConditionsTabService,
        private readonly errorTracingService: ErrorTracingService,
        private readonly colsHeadersMappingService: ColsHeaderMappingService,
        private readonly rowsMappingService: RowsMappingService,
        private readonly sectorService: SectorService,
        private readonly pricesTableService: PricesTableService,
    ) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.hasNewPayload = Boolean(this.bookingData?.booking?.priceArray?.length);
        if (changes && changes.bookingExtraData && changes.bookingExtraData.currentValue) {
            this.hasNewPayload = !!this.bookingData?.booking?.priceArray?.length;
            this.hasRetailInPayload = !!this.bookingData?.booking?.total?.retail;
            this.vehicleRentalBookingModel = makeModel(this.bookingExtraData, CarModel);
            if (this.vehicleRentalBookingModel) {
                this.vehicleColsHeader = {
                    [ColsNamesEnum.title]: '',
                    [ColsNamesEnum.total]: Yii.t('wui-shared-js', 'Total')
                };

                //Merchant
                const totalBaseMerchant: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.sumBaseByxSellLocation(
                    'Merchant',
                    Yii.t('wui-shared-js', 'Prix de base'),
                );
                const totalFeeMerchant: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.sumFeeByxSellLocation(
                    'Merchant',
                    Yii.t('wui-shared-js', 'Taxes et frais',
                    )
                );
                const totalServiceMerchant: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.total.sumServiceByxSellLocation(
                    'Merchant',
                    Yii.t('wui-shared-js', 'Services annexes'),
                );
                const totalMerchant: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.merchantOrLocalRowDefinition(
                    totalBaseMerchant,
                    totalFeeMerchant,
                    totalServiceMerchant,
                    'Merchant',
                    Yii.t('wui-shared-js', 'Dû à la réservation'),
                );
                //Local
                const totalBaseLocal: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.sumBaseByxSellLocation(
                    'Local',
                    Yii.t('wui-shared-js',
                        'Prix de base'),
                );
                const totalFeeLocal: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.sumFeeByxSellLocation(
                    'Local', Yii.t('wui-shared-js',
                        'Taxes et frais'),
                );
                const totalServiceLocal: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.total.sumServiceByxSellLocation(
                    'Local',
                    Yii.t('wui-shared-js', 'Services annexes'),
                );
                const totalLocal: IVehicleRentalPriceRow = this.vehicleRentalBookingModel.booking.merchantOrLocalRowDefinition(
                    totalBaseLocal,
                    totalFeeLocal,
                    totalServiceLocal,
                    'Local',
                    Yii.t('wui-shared-js', 'À payer sur place'),
                );
                this.hasLocalPrices = Boolean(totalLocal);
                this.vehicleTotalRows = this.hasLocalPrices ? [
                    totalMerchant,
                    totalLocal,
                ] : [
                    totalMerchant,
                ];

                this.vehicleDetailsRows = this.hasLocalPrices ? [
                    totalMerchant,
                    totalBaseMerchant,
                    totalFeeMerchant,
                    totalServiceMerchant,
                    totalLocal,
                    totalBaseLocal,
                    totalFeeLocal,
                    totalServiceLocal,
                ] : [
                    totalMerchant,
                    totalBaseMerchant,
                    totalFeeMerchant,
                    totalServiceMerchant,
                ];
            } else {
                console.error("Model data incorrect");
            }
        }
        if (changes && changes.bookingData && changes.bookingData.currentValue) {
            if (this.hasNewPayload && this.bookingData?.type[0] === BookingType?.air) {
                this.selectedTab = MenuTabs.buy;
            }
            const bookingData: TGetBookingResponse = changes.bookingData?.currentValue;
            this.error = null;
            if (bookingData?.price) {
                if (bookingData?.type && bookingData?.type[0] === BookingType?.stay) {
                    this.colsHeader = this.colsHeadersMappingService.generateColsHeaders(bookingData as IGetBookingsStayResponse);
                    this.totalRows = this.rowsMappingService.generateTotalRows(bookingData as IGetBookingsStayResponse);
                    this.detailsRows = this.rowsMappingService.generateDetailRows(bookingData as IGetBookingsStayResponse);
                    this.sectors = this.sectorService.getSectors(this.bookingData) as ISummarySectorStay[];
                }

                if (bookingData?.type[0] !== BookingType?.vehicleRental) {
                    this.conditions = this.conditionsTabService.computeConditionTableData(bookingData);
                    this.bookingPriceCardService.constructPriceData(bookingData)
                        .subscribe({
                            next: (prices: ITablePrice): void => {
                                this.prices = prices;
                            },
                            error: (error: Error): void => {
                                this.errorTracingService.captureException(error);
                                this.error = error;
                            }
                        });

                    this.bookingPriceCardService.constructStayPriceData(bookingData as IGetBookingsStayResponse)
                        .subscribe({
                            next: (prices: ITablePrice): void => {
                                this.stayPrices = prices;
                            },
                            error: (error: Error): void => {
                                this.errorTracingService.captureException(error);
                                this.error = error;
                            }
                        });
                }
            } else {
                this.prices = null;
            }
        }
    }

    public changeTab(tabCode: MenuTabs): void {
        this.menuDetailsService.changeTab(this.menuItems, tabCode);
        this.selectedTab = tabCode;
    }

    public changeTabTarifications(tabCode: MenuTabs): void {
        this.menuDetailsTarificationsService.changeTab(this.menuItemsTarifications, tabCode);
        this.selectedTab = tabCode;
    }

    public onShowPricesDetailsChange(value: DisplayType): void {
        this.showPricesDetails = value === DisplayType.pricesTable;
        this.display = value;
    }

    public menuToggleCard(): void {
        this.onCardTitleClick.emit(this.name);
    }
}
